// var $ = require("jquery");

var ajax = require("./jsonp");
var formUtil = require("./form-utils");
var cookie = require("./cookies");
var placeUser = require("./graph");

var panel = document.querySelector(".form-panel");
var container = document.querySelector(".fan-predictions");
var endpoint = "https://script.google.com/macros/s/AKfycbwdJEQYT9B8m2d3aJscARLQ1_VvrnOyEpvDtlhgXBTb0DPsb_I/exec";

var message = panel.querySelector(".message");
var form = panel.querySelector(".form");

//do not show form if it has been submitted before
if (cookie.read("huskies-tide")) {
  container.classList.add("already-sent");
}

var stored = localStorage.huskiesTideScore;
if (stored) {
  container.classList.remove("show-form");
  placeUser(stored);
}

form.querySelector(".submit").addEventListener("click", function(e) {
  e.preventDefault();
  var self = this;
  if (self.disabled) return;

  //handle form elements correctly
  var packet = formUtil.package(form);
  var errorMsg = "";
  if (!packet) {
    errorMsg = "We need your prediction in order to add you!";
  } else if (isNaN(packet.tide) || isNaN(packet.huskies)) {
    errorMsg = "Scores must be numbers.";
  } else if (Math.max(packet.tide, packet.huskies) > 70) {
    errorMsg = "Scores over 70 points are not accepted.";
  } else if (packet.huskies == packet.tide) {
    errorMsg = "Scores cannot be equal.";
  } else if (packet.tide < 0 || packet.huskies < 0) {
    errorMsg = "Scores must be positive.";
  }

  if (errorMsg) {
    panel.classList.add("invalid");
    document.querySelector(".validation.error").innerHTML = errorMsg;
    return;
  } else {
    panel.classList.remove("invalid");
  }

  self.disabled = true;

  var submission = ajax(endpoint, packet, function(data) {
    container.classList.remove("show-form");
    container.classList.add("already-sent");
    cookie.write("huskies-tide", true);
    var stored = packet.huskies + "-" + packet.tide;
    localStorage.huskiesTideScore = stored;
    placeUser(stored);
  });

  panel.classList.add("show-message");

});

window.clearSent = function() {
  cookie.clear("huskies-tide");
};